import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_4W_44_4W_9_99',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_4w_44_4w_9_99_usd',
			EUR: 'simple_premium_4w_39_4w_9_99_eur',
			GBP: 'simple_premium_4w_44_4w_9_99_gbp',
			AUD: 'simple_premium_4w_73_4w_14_99_aud',
			CAD: 'simple_premium_4w_73_4w_14_99_cad',
			DKK: 'simple_premium_4w_379_4w_69_dkk',
			SEK: 'simple_premium_4w_585_4w_110_sek',
			NOK: 'simple_premium_4w_585_4w_110_nok',
			MXN: 'simple_premium_4w_729_4w_129_mxn',
			BRL: 'simple_premium_4w_99_4w_39_brl',
			TRY: 'simple_premium_4w_1499_4w_333_try',
			ARS: 'simple_premium_4w_58000_4w_12990_ars',
			COP: 'simple_premium_4w_178000_4w_39990_cop',
			CLP: 'simple_premium_4w_42000_4w_9990_clp',
		},
		primer: 'prd_uiSU5zmZM0eJ',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 4,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 28,
		priceMap: {
			USD: 9.99,
			EUR: 9.99,
			GBP: 9.99,
			AUD: 14.99,
			CAD: 14.99,
			DKK: 69,
			SEK: 110,
			NOK: 110,
			MXN: 129,
			BRL: 39,
			TRY: 333,
			ARS: 12990,
			COP: 39990,
			CLP: 9990,
		},
		originalPriceMap: {
			USD: 44,
			EUR: 39,
			GBP: 44,
			AUD: 73,
			CAD: 73,
			DKK: 379,
			SEK: 585,
			NOK: 585,
			MXN: 729,
			BRL: 99,
			TRY: 1499,
			ARS: 58000,
			COP: 178000,
			CLP: 42000,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 44,
			EUR: 39,
			GBP: 44,
			AUD: 73,
			CAD: 73,
			DKK: 379,
			SEK: 585,
			NOK: 585,
			MXN: 729,
			BRL: 99,
			TRY: 1499,
			ARS: 58000,
			COP: 178000,
			CLP: 42000,
		},
	},
}
